var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.tag)+" "),_c('v-card',[_c('v-card-title',[_vm._v(" Messages ")]),_c('v-card-text',[_c('v-list',_vm._l((_vm.tag.Messages),function(message,i){return _c('Message',{key:i,attrs:{"message":message}})}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }